const copyRightsConstantEN = {
  text: 'Copyright {{year}}. All rights reserved by Sayma',
};

export default copyRightsConstantEN;
